export default element => {
  element.style.animation = 'none'
  window.setTimeout(() => {
    element.style.animation = ''
  }, 10)
}
